import React from "react";
import { CalendarBlank, X, ArrowRight } from "@phosphor-icons/react";

/**
 * @param {Object} dateRange - { from: string, to: string }
 * @param {Function} setDateRange - State setter for dateRange
 * @param {string} minDate - (Optional) Earliest allowed date from backend
 * @param {string} maxDate - (Optional) Latest allowed date (defaults to Today)
 */
export function DateRangeFilter({
  dateRange,
  setDateRange,
  minDate,
  maxDate = new Date().toISOString().split("T")[0],
}) {
  const handleFromChange = (e) => {
    const newFrom = e.target.value;
    setDateRange((prev) => ({ ...prev, from: newFrom }));
  };

  const handleToChange = (e) => {
    const newTo = e.target.value;
    setDateRange((prev) => ({ ...prev, to: newTo }));
  };

  const clearFilter = () => {
    setDateRange({ from: "", to: "" });
  };

  const safeMin = minDate
    ? new Date(minDate).toISOString().split("T")[0]
    : undefined;

  return (
    <div className="inline-flex items-center bg-white border border-slate-200 rounded-lg shadow-sm hover:border-green-400 transition-colors p-1">
      <div className="flex items-center gap-2 px-3 border-r border-slate-100 bg-slate-50/50 rounded-l-md py-1.5">
        <CalendarBlank size={18} className="text-green-600" weight="bold" />
        {/* <span className="text-xs font-bold text-slate-500 uppercase tracking-wide">
          Filter Date
        </span> */}
      </div>

      <div className="flex items-center gap-2 px-3">
        <div className="relative group">
          <label className="absolute -top-2 left-0 text-[9px] font-bold text-slate-400 bg-white px-1 opacity-0 group-hover:opacity-100 transition-opacity">
            Start
          </label>
          <input
            type="date"
            value={dateRange.from}
            onChange={handleFromChange}
            min={safeMin}
            max={dateRange.to || maxDate}
            className="text-xs font-medium text-slate-700 border-none p-1 focus:ring-0 cursor-pointer bg-transparent outline-none placeholder-slate-400"
          />
        </div>

        <ArrowRight size={14} className="text-slate-300" />

        <div className="relative group">
          <label className="absolute -top-2 left-0 text-[9px] font-bold text-slate-400 bg-white px-1 opacity-0 group-hover:opacity-100 transition-opacity">
            End
          </label>
          <input
            type="date"
            value={dateRange.to}
            onChange={handleToChange}
            min={dateRange.from || safeMin}
            max={maxDate}
            className="text-xs font-medium text-slate-700 border-none p-1 focus:ring-0 cursor-pointer bg-transparent outline-none"
          />
        </div>
      </div>

      {(dateRange.from || dateRange.to) && (
        <button
          onClick={clearFilter}
          className="ml-1 p-1.5 rounded-md hover:bg-red-50 group border-l border-slate-100 transition-all"
          title="Clear Dates"
        >
          <X
            size={14}
            weight="bold"
            className="text-slate-400 group-hover:text-red-500 transition-colors"
          />
        </button>
      )}
    </div>
  );
}
